import { NgIf } from '@angular/common';
import { Component, ViewChild } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { Sitecore } from '@frontend/sports/common/client-config-data-access';

import { ExpansionPanelComponent } from '../common/expansion-panel/expansion-panel.component';
import { MinigamesComponent } from '../minigames/minigames.component';
import { MiniGamesService } from '../minigames/minigames.service';
import { WidgetComponent } from '../widget/core/widget-registry.service';
import { MiniGamesTrackingService } from './minigames-tracking.service';
import { MiniGamesWidgetCollapsedEvent, MiniGamesWidgetExpandedEvent } from './sports.event';

@Component({
    selector: 'ms-minigames-column',
    templateUrl: './minigames-column.component.html',
    providers: [MiniGamesService, MiniGamesTrackingService],
    imports: [MinigamesComponent, ExpansionPanelComponent, NgIf],
})
export class MinigamesColumnComponent extends WidgetComponent<never> {
    collapsed = false;
    @ViewChild(MinigamesComponent) minigamesComponent?: MinigamesComponent;
    areMiniGamesEnabled: boolean;

    constructor(
        public sitecore: Sitecore,
        private miniGamesService: MiniGamesService,
    ) {
        super();
        this.miniGamesService.miniGamesEnabled.pipe(takeUntilDestroyed()).subscribe((resp) => {
            this.areMiniGamesEnabled = resp;
        });
    }

    panelToggled(): void {
        this.collapsed = !this.collapsed;

        if (!this.minigamesComponent) {
            return;
        }

        const event = this.collapsed ? new MiniGamesWidgetCollapsedEvent() : new MiniGamesWidgetExpandedEvent();
        this.miniGamesService.postEventsToCasino(event, this.minigamesComponent.casinoIframe);
    }
}
